import { PageTitle, SlidingTabs } from '@/components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AboutCompany } from './tabComponents/AboutCompany';
import { ArrowLeft } from 'lucide-react';
import { CompanyDepartment } from './tabComponents/CompanyDepartment';
import { Finance } from './tabComponents/CompanyFinance';
import { CompanyClub } from './tabComponents/CompanyClub';
import { CompanyEmployees } from './tabComponents/CompanyEmployees';

export const CompanyDetails = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const tabParam = searchParams.get('tab');
	const defaultActiveTab =
		tabParam === 'sobre'
			? 'sobre'
			: tabParam === 'departamentos'
			  ? 'departamentos'
			  : tabParam === 'financeiro'
			    ? 'financeiro'
			    : tabParam === 'clubes'
			      ? 'clubes'
			      : tabParam === 'colaboradores'
			        ? 'colaboradores'
			        : 'sobre';

	const tabs = [
		{
			id: 'sobre',
			label: 'Sobre a empresa',
			children: <AboutCompany />,
		},
		{
			id: 'clubes',
			label: 'Clubes da empresa',
			children: <CompanyClub />,
		},
		{
			id: 'departamentos',
			label: 'Departamentos da empresa',
			children: <CompanyDepartment />,
		},
		{
			id: 'colaboradores',
			label: 'Colaboradores da empresa',
			children: <CompanyEmployees />,
		},
		{
			id: 'financeiro',
			label: 'Financeiro da empresa',
			children: <Finance />,
		},
	];

	return (
		<section className="animate-fade-in space-y-6 px-4 py-6">
			<div className="space-y-1">
				<div className="flex items-center gap-6">
					<button
						onClick={() => navigate('/admin/empresas')}
						className="group flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border border-stone-100 bg-white transition-all hover:border-stone-200 hover:shadow-sm"
					>
						<ArrowLeft
							size={20}
							className="text-stone-400 group-hover:text-stone-900"
						/>
					</button>
					<div>
						<PageTitle text="Empresas Contratantes" />
						<div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.1em] text-stone-300">
							<span>EMPRESAS</span>
							<span className="font-normal text-stone-200">
								/
							</span>
							<span className="text-stone-900">DETALHES</span>
						</div>
					</div>
				</div>
			</div>
			<SlidingTabs
				key={defaultActiveTab}
				tabs={tabs}
				defaultActiveTab={defaultActiveTab}
			/>
		</section>
	);
};
